<template lang="pug">
#usersContent
  .users(v-for="(user, index) in userList" :key="index")
    .list
      el-image(:src="circleUrl(user)")
        .userAvatar(slot="error") {{userName(user.userName)}}
      .name(:title="user.userName") {{ user.userName }}
      span.resultStatus(:class="`resultNode${user.result}`") {{statusName(user.result)}}
      .approvalTime(v-if="user.approvalTime") 时间：{{user.approvalTime}}
    .comment(v-if="user.comment" title="审批意见")
      i.el-icon-chat-dot-round
      | {{user.comment}}
    .file-list(v-if="user.flowNodeFileVos?.length>0")
      .uplist 审批附件:
      .file-label(v-for="(file, index) in user.flowNodeFileVos", :key="file.fileId", :title="file.fileName" )
        img(:src="className(file)")
        .fileName(@click="preview(file,user.flowNodeFileVos)") {{ file.fileName }}
        i.el-icon-download(title="下载" @click.stop="downLoadFile(file)" )
  //- .comment(v-if="hasComment" title="节点处理信息")
  //-   i.el-icon-chat-dot-round
  //-   | {{nodeStatus}}{{result}}
</template>

<script>
import { gettouxAvatar } from "@/CommonDP/utils";
import { tableRowIcon, filePreviewV1 } from "@/CommonDP/utils/docPublic";
import { downloadUrltoken, downloadFile } from "@/CommonDP/utils/index";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
export default {
  props: {
    userList: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    nodeStatus: { type: String, default: "" },
    result: { type: String, default: "" },
    uuid: { type: String, default: "" }
  },
  data () {
    return {
      roleIcon: require("@/CommonDP/assets/doc/role.png")
    };
  },
  computed: {
    hasComment() {
      return this.nodeStatus !== '3' && this.result;
    },
    flowInstanceId() {
      return getApprove(this.uuid).getMessage()?.flowInstanceId || "";
    }
  },
  methods: {
    className(row) {
      return tableRowIcon(row);
    },
    preview(file, list) {
      const data = {
        fileType: file.fileType,
        fileId: file.fileId,
        versionId: file.versionIds || file.fileVersion,
        flowInstanceId: this.flowInstanceId,
        status: file.status,
        parentId: file.parentId
      };
      filePreviewV1(data, list);
    },
    downLoadFile(row) {
      const fileId = row.fileId;
      const url = downloadUrltoken("EnterpriseDoc", fileId);
      downloadFile(url);
    },
    circleUrl(item) {
      return gettouxAvatar(item.userId);
    },
    errorHandler() {
      return true;
    },
    deleteUser(user) {
      if (this.disabled) {
        return;
      }
      this.$confirm(`确认${this.deleteToolTip(user)}:${user.name}?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      }).then(async () => {
        this.$emit("deleteUser", user);
      }).catch(() => {
        // this.$message.info("已取消");
      });
    },
    deleteToolTip(user) {
      const tipDescribe = {
        0: () => { return "删除人员"; },
        1: () => { return "删除系统角色"; },
        2: () => { return "删除专业角色"; },
        3: () => { return "删除项目角色"; }
      };
      return tipDescribe[user.type] ? tipDescribe[user.type]() : console.log("未配置");
    },
    statusName(result) {
      switch (result) {
        case "1":
          return "已通过";
        case "10":
          return "自动通过";
        case "2":
          return "审批中";
        case "3":
          return "发起";
        case "4":
          return "重新发起";
        case "5":
          return "已撤回";
        case "8":
          return "终止";
        case "0":
          return "已驳回";
        default:
          return "";
      }
    },
    userName(val) {
      return val.charAt(0) || "";
    }
  }

};
</script>

<style lang="scss" scoped>
#usersContent {
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .users {
    width: 100%;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
  }

  .list {
    padding: 5px 10px;
    height: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 5px;

    .el-image {
      width: 20px;
      height: 20px;
      border-radius: 5px;
      object-fit: contain;
    }

    /deep/.userAvatar {
      line-height: 20px;
      font-size: 12px;
      border-radius: 5px;
      text-align: center;
      background-color: var(--theme-color);
      color: #fff;
    }

    .name {
      max-width: 70px;
      overflow: hidden;
      text-overflow:ellipsis;
      margin-left: 5px;
      white-space:nowrap;
      font-size: 12px;
      line-height: 28px;
    }

    .approvalTime {
      margin-left: auto;
    }

    i {
      margin-left: 5px;
      font-size: 14px;
      line-height: 28px;
      cursor: pointer;
    }

    .noClick {
      cursor: not-allowed;
    }
  }

  .users:hover {
    background-color: #ebeef5;
  }
}

.comment {
  // margin-left: 25px;
  padding-left: 10px;
  font-size: 12px;
  border-radius: 6px;
  line-height: 28px;
  background-color: #ebeef5;
  i{
    font-size: 16px;
    margin-right: 6px;
  }
}
.file-list{
  display: flex;
  flex-direction: column;
  .uplist{
    margin-left: 6px;
    color: #5584ff
  }
  .file-label{
    border-radius: 6px;
    padding: 0 6px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  img{
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  .fileName{
    cursor: pointer;
    overflow-x: auto;
  }
  .el-icon-download{
    color: #5584ff;
    cursor: pointer;
    margin-left: auto;
  }
  .file-label:hover{
    background-color: rgba(#409eff, 0.2);
  }
}

.result {
  margin-left: 5px;
  padding: 5px;
  border-radius: 6px;
}

.resultStatus {
  margin-left: 10px;
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
  font-size: 12px !important;
  line-height: 16px;
  font-weight: 400 !important;
}
// 发起
.resultNode3,.resultNode4{
  background: rgba(0, 188, 212, 0.10);
  color: #00BCD4;
}
// 通过
.resultNode1,.resultNode10{
  background: rgba(16, 166, 103, 0.10);
  color: #10A667;
}
// 审批中
.resultNode2 {
  background: rgba(255, 122, 0, 0.10);
  color: #FF7A00;
}
// 终止
.resultNode8 {
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}
// 已驳回
.resultNode0 {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
}
</style>
